import { render, staticRenderFns } from "./ImportarMedicamentos.vue?vue&type=template&id=5a20906c"
import script from "./ImportarMedicamentos.vue?vue&type=script&lang=js"
export * from "./ImportarMedicamentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports